<template>
    <div>
      <el-row>
        <el-col :span="17">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
<!--            <el-breadcrumb-item>Factory Id:{{factory.id}} Supplier:{{factory.supplier}} Location:{{factory.location}} </el-breadcrumb-item>-->
            <el-breadcrumb-item>Output</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-card>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="Production Overview" name="1">
            <div style="display: flex">
            <el-date-picker
              style="flex: 1"
              v-model="dateRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="Starts Date"
              end-placeholder="End Date"
              value-format="yyyy-MM-dd"
              :disabled-date="disabledDate"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-select
              style="width: 100%;flex: 1"
              v-model="value"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="Keyword search by item"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item">
              </el-option>
            </el-select>
            <el-button type="primary" @click="onSubmit3()">Submit</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Production Overview(Machine)" name="2">
            <div style="display: flex">
            <el-date-picker
              style="flex: 1"
              v-model="dateRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="Starts Date"
              end-placeholder="End Date"
              value-format="yyyy-MM-dd"
              :disabled-date="disabledDate"
              :picker-options="pickerOptions">
            </el-date-picker>
              <el-select
                style="width: 100%;flex: 1"
                v-model="value"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Keyword search by item"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item">
                </el-option>
              </el-select>
              <el-button type="primary" @click="onSubmit3()">Submit</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Item Production Query(Machine)" name="3">
            <div style="display: flex">
              <el-date-picker
                style="flex: 1"
                v-model="dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="-"
                start-placeholder="Starts Date"
                end-placeholder="End Date"
                value-format="yyyy-MM-dd"
                :disabled-date="disabledDate"
                :picker-options="pickerOptions">
              </el-date-picker>
              <!--          <el-select style="flex: 1" v-model="form.brand" placeholder="Please select brand" @change="changeBrand">-->
              <!--            <el-option :key="item.key" v-for="item in brandList" :value="item"></el-option>-->
              <!--          </el-select>-->
              <el-select
                style="width: 100%;flex: 1"
                v-model="value"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Keyword search by item"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item">
                </el-option>
              </el-select>
              <el-button type="primary" @click="onSubmit()">Submit</el-button>
            </div>
          </el-tab-pane>
<!--          <el-tab-pane label="Average Weekly Output" name="4">-->
<!--            <div style="display: flex">-->
<!--              <el-select-->
<!--                style="width: 100%;flex: 1"-->
<!--                v-model="value"-->
<!--                multiple-->
<!--                filterable-->
<!--                remote-->
<!--                reserve-keyword-->
<!--                placeholder="Keyword search by item"-->
<!--                :remote-method="remoteMethod"-->
<!--                :loading="loading">-->
<!--                <el-option-->
<!--                  v-for="item in options"-->
<!--                  :key="item.value"-->
<!--                  :value="item">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--              <el-button type="primary" @click="onSubmit()">Submit</el-button>-->
<!--            </div>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </el-card>
<!--      <el-card>-->
<!--        <el-table-->
<!--          :data="tableData1"-->
<!--          style="width: 100%"-->
<!--          row-key="id"-->
<!--          border-->
<!--          lazy-->
<!--          :load="load"-->
<!--          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">-->
<!--          <el-table-column-->
<!--            prop="date"-->
<!--            label="Date"-->
<!--            width="180">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="address"-->
<!--            label="Supplier Name">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="name"-->
<!--            label="Factory Id">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="machineId"-->
<!--            label="Machine Id">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="itmes"-->
<!--            label="Itmes"-->
<!--            show-overflow-tooltip-->
<!--            width="500">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="img"-->
<!--            label="Img">-->
<!--            <template slot-scope="scope">-->
<!--              <img :src="scope.row.img" min-width="30" height="30">-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="quantity"-->
<!--            label="Quantity">-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </el-card>-->
      <el-card>
        <div style="width:1200px;height:450px" ref="chart"></div>
      </el-card>
      <el-card v-if="activeName !== '4'">
        <el-button type="primary" size="mini" @click="onSubmit2()">Filter</el-button>
        <el-checkbox-group
          v-model="itemsChoose">
          <el-checkbox v-for="item in itemsDis" :label="item" :key="item">{{item}}</el-checkbox>
        </el-checkbox-group>
      </el-card>
    </div>
</template>

<script>
import * as echarts from 'echarts/lib/echarts'
export default {
  name: 'FollowUp',
  data () {
    return {
      lastDate: '',
      activeName: '1',
      itemsDis: [],
      itemsChoose: [],
      newItems: [],
      options: [],
      value: [],
      loading: false,
      seriesVar: [],
      items: [],
      quanReportList: [],
      form: [],
      brandList: [],
      factory: '',
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last month',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last 3 months',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      tableData1: [],
      // tableData1: [{
      //   id: 1,
      //   date: '2016-05-02',
      //   name: '1',
      //   address: 'TECH',
      //   hasChildren: true
      // }, {
      //   id: 2,
      //   date: '2016-05-04',
      //   name: '1',
      //   address: 'TECH',
      //   hasChildren: true
      // }],
      dateRangeVar: [],
      dateRange: [],
      // dateRange: [new Date(), new Date()],
      calenderDate: '',
      // http://localhost:8081/file/upload/img/
      uploadImgUrl: 'http://localhost:8081' + '/file/upload/img/'
    }
  },
  watch: {
    // itemsChoose (newVal, oldVal) {
    //   console.log(newVal)
    //   const list = []
    //   const seriesNew = []
    //   for (let i = 0; i < newVal.length; i++) {
    //     list.push(newVal[i].split('|')[0])
    //     for (let j = 0; j < this.seriesVar.length; j++) {
    //       if (this.seriesVar[j].name === newVal[i].split('|')[0]) {
    //         seriesNew.push(this.seriesVar[j])
    //       }
    //     }
    //   }
    //   this.items = list
    //   this.seriesVar = seriesNew
    //   this.initCharts()
    // },
    dateRange (newVal, oldVal) {
      if (this.activeName === '1') {
        this.itemsChoose = []
        this.$http.get('/factory/getDateList?startDate=' + newVal[0] + '&&endDate=' + newVal[1])
          .then((ress) => {
            console.log('ress.data')
            console.log(ress.data)
            this.dateRangeVar = ress.data
            this.$http.get('/factory/getQuanReportList?startDate=' + newVal[0] + '&&endDate=' + newVal[1])
              .then((res) => {
                console.log('res.data')
                console.log(res.data)
                this.seriesVar = []
                this.items = []
                const itemList = []
                const seriesList = []
                this.seriesVar = []
                this.quanReportList = res.data
                for (let i = 0; i < res.data.length; i++) {
                  const dataVar = []
                  for (let j = 0; j < this.dateRangeVar.length; j++) {
                    if (this.dateRangeVar[j] === res.data[i].date) {
                      dataVar.push(res.data[i].quantity)
                    } else {
                      dataVar.push('')
                    }
                  }
                  itemList.push(res.data[i].item)
                  const mapv = {}
                  mapv.name = res.data[i].item
                  mapv.type = 'bar'
                  // mapv.stack = 'daily'
                  // if (this.activeName === '2') {
                  //   mapv.stack = res.data[i].machine_id
                  // }
                  mapv.data = dataVar
                  mapv.markLine = {
                    data: [
                      { type: 'average', name: 'average' }
                    ]
                  }
                  seriesList.push(mapv)
                }
                this.seriesVar = seriesList
                this.items = itemList
                console.log(this.items)
                console.log(this.seriesVar)
                this.initCharts()
                if (itemList.length > 0) {
                  this.$http.get('/factory/getItemDisList?items=' + itemList)
                    .then((ress) => {
                      this.itemsDis = ress.data
                      this.$http.get('/factory/getSubItemDisList?items=' + itemList)
                        .then((resss) => {
                          this.itemsDis = this.itemsDis.concat(resss.data)
                        })
                    })
                }
              })
          })
      } else if (this.activeName === '2') {
        this.itemsChoose = []
        this.$http.get('/factory/getDateList?startDate=' + newVal[0] + '&&endDate=' + newVal[1])
          .then((ress) => {
            console.log('ress.data')
            console.log(ress.data)
            this.dateRangeVar = ress.data
            this.$http.get('/factory/getQuanReportListBymachine?startDate=' + newVal[0] + '&&endDate=' + newVal[1])
              .then((res) => {
                console.log('res.data')
                console.log(res.data)
                this.seriesVar = []
                this.items = []
                const itemList = []
                const seriesList = []
                this.seriesVar = []
                this.quanReportList = res.data
                for (let i = 0; i < res.data.length; i++) {
                  // const dataVar = [2, 3, 4, 5, 6, 7]
                  const dataVar = []
                  for (let j = 0; j < this.dateRangeVar.length; j++) {
                    if (this.dateRangeVar[j] === res.data[i].date) {
                      dataVar.push(res.data[i].quantity)
                    } else {
                      dataVar.push('')
                    }
                  }
                  itemList.push(res.data[i].item)
                  const mapv = {}
                  mapv.name = res.data[i].item
                  mapv.type = 'bar'
                  // mapv.stack = 'daily'
                  mapv.stack = res.data[i].machine_id
                  mapv.tooltip = {
                    trigger: 'item',
                    formatter: function (params) {
                      return 'Machine Id:' + res.data[i].machine_id
                    }
                  }
                  // mapv.label = {
                  //   position: 'top',
                  //   color: '#333',
                  //   show: true,
                  //   formatter: function (param) {
                  //     return res.data[i].machine_id
                  //     // console.log(param);
                  //   }
                  // }
                  mapv.data = dataVar
                  seriesList.push(mapv)
                }
                this.seriesVar = seriesList
                this.items = itemList
                console.log(this.items)
                console.log(this.seriesVar)
                this.initCharts()
                if (itemList.length > 0) {
                  this.$http.get('/factory/getItemDisList?items=' + itemList)
                    .then((ress) => {
                      this.itemsDis = ress.data
                      this.$http.get('/factory/getSubItemDisList?items=' + itemList)
                        .then((resss) => {
                          this.itemsDis = this.itemsDis.concat(resss.data)
                        })
                    })
                }
              })
          })
      } else if (this.activeName === '4') {
        // const myChart = echarts.init(this.$refs.chart)
        // myChart.setOption({}, true)
        const myChart = echarts.init(this.$refs.chart)
        myChart.setOption({
          title: {
            text: 'ECharts 入门示例'
          },
          tooltip: {},
          legend: {
            data: ['销量']
          },
          xAxis: {
            data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
          },
          yAxis: {},
          series: [
            {
              name: '销量',
              type: 'bar',
              data: [5, 20, 36, 10, 10, 20]
            }
          ]
        }, true)
        // const list = ['TOOL-BM-CP', 'BAM1191-CL', 'BAM1306-FIL', 'BAM1290-FC', 'BAM1344-BL', 'BAM1207-BTL']
        // const seriesNew = [
        //   {
        //     name: 'TOOL-BM-CP',
        //     type: 'bar',
        //     data: [2, 3, 4, 5, 6, 7]
        //   },
        //   {
        //     name: 'BAM1191-CL',
        //     type: 'bar',
        //     data: [21, 31, 41, 51, 61, 71]
        //   }
        // ]
        // this.initCharts()
      } else {
        console.log(this.activeName)
      }
    },
    calenderDate (newVal, oldVal) {
      console.log(newVal.toLocaleString('london', { hour12: false }).replace(/[/]+/g, '-'))
      // console.log(oldVal)
      // this.calenderDate = this.formatDate(newVal)
      // this.allcalendar()
    }
  },
  mounted () {
    // function timestampToTime (times) {
    //   const year = new Date().getFullYear()
    //   const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
    //   const day = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
    //   return year + '-' + month + '-' + day
    // }
    // const time = new Date()
    // const nowTime = timestampToTime(time.toLocaleString('en-US', { hour12: false }).split(' '))
    //
    // this.dateRange = [nowTime, nowTime]
    // console.log(22222222)
    // console.log(this.dateRange)
    // this.dateRangeVar = [new Date()]
    // this.initCharts()
    this.getMachineJointitemDateLast()
  },
  created () {
    this.factory = this.$route.query
    this.getBrandList()
  },
  methods: {
    async getMachineJointitemDateLast () {
      await this.$http.get('/machine/getMachineJointitemDateLast')
        .then((ress) => {
          this.lastDate = ress.data[0].dueDate
          this.dateRange = [this.lastDate.split(' ')[0], this.lastDate.split(' ')[0]]
        })
    },
    handleClick (tab, event) {
      // function timestampToTime (times) {
      //   const year = new Date().getFullYear()
      //   const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
      //   const day = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      //   return year + '-' + month + '-' + day
      // }
      // const time = new Date()
      // const nowTime = timestampToTime(time.toLocaleString('en-US', { hour12: false }).split(' '))
      if (tab.index === '0' || tab.index === '1') {
        // this.dateRange = [nowTime, nowTime]
        this.dateRange = [this.lastDate.split(' ')[0], this.lastDate.split(' ')[0]]
      } else {
        // this.dateRange = []
        const myChart = echarts.init(this.$refs.chart)
        myChart.setOption({}, true)
        this.itemsDis = []
      }
    },
    onSubmit3 () {
      const varchoose = this.value
      const list = []
      const seriesNew = []
      for (let i = 0; i < varchoose.length; i++) {
        list.push(varchoose[i].split('|')[0])
        for (let j = 0; j < this.seriesVar.length; j++) {
          if (this.seriesVar[j].name === varchoose[i].split('|')[0]) {
            seriesNew.push(this.seriesVar[j])
          }
        }
      }
      this.initCharts2(list, seriesNew)
    },
    onSubmit () {
      if (this.value.length < 1) {
        this.$notify({
          title: 'Please enter item',
          type: 'warning'
        })
        return
      }
      const list = []
      // const seriesNew = []
      for (let i = 0; i < this.value.length; i++) {
        list.push(this.value[i].split('|')[0])
        // for (let j = 0; j < this.seriesVar.length; j++) {
        //   if (this.seriesVar[j].name === this.value[i].split('|')[0]) {
        //     seriesNew.push(this.seriesVar[j])
        //   }
        // }
      }
      // this.items = list
      // this.seriesVar = seriesNew
      // console.log('aaaaaa')
      // console.log(this.items)
      // console.log(this.seriesVar)
      // this.initCharts()
      this.itemsChoose = []
      this.$http.get('/factory/getDateList?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1])
        .then((ress) => {
          console.log('ress.data')
          console.log(ress.data)
          this.dateRangeVar = ress.data
          this.$http.get('/factory/getQuanReportListByitem?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1] + '&&items=' + list)
            .then((res) => {
              console.log('res.data')
              console.log(res.data)
              this.seriesVar = []
              this.items = []
              const itemList = []
              const seriesList = []
              this.seriesVar = []
              this.quanReportList = res.data
              for (let i = 0; i < res.data.length; i++) {
                // const dataVar = [2, 3, 4, 5, 6, 7]
                const dataVar = []
                for (let j = 0; j < this.dateRangeVar.length; j++) {
                  if (this.dateRangeVar[j] === res.data[i].date) {
                    dataVar.push(res.data[i].quantity)
                  } else {
                    dataVar.push('')
                  }
                }
                itemList.push(res.data[i].item)
                const mapv = {}
                mapv.name = res.data[i].item
                mapv.type = 'bar'
                // mapv.stack = 'daily'
                mapv.stack = res.data[i].machine_id
                mapv.tooltip = {
                  trigger: 'item',
                  formatter: function (params) {
                    return 'Machine Id:' + res.data[i].machine_id
                  }
                }
                // mapv.label = {
                //   position: 'top',
                //   color: '#333',
                //   show: true,
                //   formatter: function (param) {
                //     return res.data[i].machine_id
                //     // console.log(param);
                //   }
                // }
                mapv.data = dataVar
                // mapv.markLine = {
                //   data: [
                //     { type: 'average', name: 'average' }
                //   ]
                // }
                seriesList.push(mapv)
              }
              this.seriesVar = seriesList
              this.items = itemList
              console.log(this.items)
              console.log(this.seriesVar)
              this.initCharts()
              if (itemList.length > 0) {
                this.$http.get('/factory/getItemDisList?items=' + itemList)
                  .then((ress) => {
                    this.itemsDis = ress.data
                    this.$http.get('/factory/getSubItemDisList?items=' + itemList)
                      .then((resss) => {
                        this.itemsDis = this.itemsDis.concat(resss.data)
                      })
                  })
              } else {
                this.$notify({
                  title: 'Item was not produced during the date',
                  type: 'info'
                })
              }
            })
        })
    },
    onSubmit2 () {
      const list = []
      const seriesNew = []
      for (let i = 0; i < this.itemsChoose.length; i++) {
        list.push(this.itemsChoose[i].split('|')[0])
        for (let j = 0; j < this.seriesVar.length; j++) {
          if (this.seriesVar[j].name === this.itemsChoose[i].split('|')[0]) {
            seriesNew.push(this.seriesVar[j])
          }
        }
      }
      // this.items = list
      // this.seriesVar = seriesNew
      this.initCharts2(list, seriesNew)
    },
    async changeBrand () {
      console.log(1)
    },
    async remoteMethod (query) {
      // console.log(1111)
      // console.log(query)
      // console.log(this.list)
      // console.log(this.brandList)
      if (query !== '') {
        this.loading = true
        await this.$http.get('/factory/getItemListByKeyword?keyword=' + query)
          .then((ress) => {
            this.options = ress.data
            this.newItems = ress.data
          })
        setTimeout(() => {
          this.loading = false
          this.options = this.newItems.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    async getBrandList () {
      await this.$http.get('/machine/getBrandList')
        .then((ress) => {
          this.brandList = ress.data
        })
    },
    disabledDate (time) {
      console.log(1212312313)
      console.log(time.getTime())
    },
    initCharts3 (a, b) {
      const myChart = echarts.init(this.$refs.chart)
      myChart.setOption({
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            start: 1,
            end: 100,
            bottom: '20'
          }
        ],
        title: {
          // text: '2023/10/12-2023/10/17'
          // text: this.dateRange
        },
        label: { // 柱状图 内部 显示数值
          show: true
        },
        tooltip: {

        },
        legend: {
          // data: ['TOOL-BM-CP', 'BAM1191-CL', 'BAM1306-FIL', 'BAM1290-FC', 'BAM1344-BL', 'BAM1207-BTL']
          data: a
        },
        xAxis: {
          data: ['2023/10/12', '2023/10/13', '2023/10/14', '2023/10/15', '2023/10/16', '2023/10/17']
          // data: this.dateRangeVar
        },
        yAxis: {
        },
        series: b
      }, true)
    },
    initCharts2 (a, b) {
      const myChart = echarts.init(this.$refs.chart)
      myChart.setOption({
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            start: 1,
            end: 100,
            bottom: '20'
          }
        ],
        title: {
          // text: '2023/10/12-2023/10/17'
          // text: this.dateRange
        },
        label: { // 柱状图 内部 显示数值
          show: true
        },
        tooltip: {

        },
        legend: {
          // data: ['TOOL-BM-CP', 'BAM1191-CL', 'BAM1306-FIL', 'BAM1290-FC', 'BAM1344-BL', 'BAM1207-BTL']
          data: a
        },
        xAxis: {
          // data: ['2023/10/12', '2023/10/13', '2023/10/14', '2023/10/15', '2023/10/16', '2023/10/17']
          data: this.dateRangeVar
        },
        yAxis: {

        },
        series: b
        // [
        // {
        //   name: 'TOOL-BM-CP',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 3, 4, 5, 6, 7],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1191-CL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [21, 31, 41, 51, 61, 71],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1306-FIL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 3, 4, 5, 6, 7],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1290-FC',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [5, 20, 36, 10, 10, 20],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1344-BL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 3, 20, 20, 30, 0],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1207-BTL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 30, 0, 40, 20, 0],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // }
        // {
        //   name: 'item quantity required(open)',
        //   type: 'bar',
        //   data: [90, 90, 120, 120, 80, 100]
        // }
        // ]
      }, true)
    },
    initCharts () {
      const myChart = echarts.init(this.$refs.chart)
      myChart.setOption({
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            start: 1,
            end: 100,
            bottom: '20'
          }
        ],
        title: {
          // text: '2023/10/12-2023/10/17'
          // text: this.dateRange
        },
        label: { // 柱状图 内部 显示数值
          show: true
        },
        tooltip: {

        },
        legend: {
          // data: ['TOOL-BM-CP', 'BAM1191-CL', 'BAM1306-FIL', 'BAM1290-FC', 'BAM1344-BL', 'BAM1207-BTL']
          data: this.items
        },
        xAxis: {
          // data: ['2023/10/12', '2023/10/13', '2023/10/14', '2023/10/15', '2023/10/16', '2023/10/17']
          data: this.dateRangeVar
        },
        yAxis: {

        },
        series: this.seriesVar
        // [
        // {
        //   name: 'TOOL-BM-CP',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 3, 4, 5, 6, 7],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1191-CL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [21, 31, 41, 51, 61, 71],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1306-FIL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 3, 4, 5, 6, 7],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1290-FC',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [5, 20, 36, 10, 10, 20],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1344-BL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 3, 20, 20, 30, 0],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // },
        // {
        //   name: 'BAM1207-BTL',
        //   type: 'bar',
        //   // stack: 'daily',
        //   data: [2, 30, 0, 40, 20, 0],
        //   markLine: {
        //     data: [
        //       { type: 'average', name: 'average' }
        //     ]
        //   }
        // }
        // {
        //   name: 'item quantity required(open)',
        //   type: 'bar',
        //   data: [90, 90, 120, 120, 80, 100]
        // }
        // ]
      }, true)
    },
    load (tree, treeNode, resolve) {
      setTimeout(() => {
        resolve([
          {
            id: 31,
            date: '2023-11-03',
            name: '1',
            address: 'TECH',
            machineId: '1',
            quantity: '1000',
            img: 'http://45.32.181.176:8081/c3152c59639f483298411c4d79ab3f4d.png',
            itmes: '105000DSK1,105000JAR1,81170030-CP1,81170030-BT,81170050-CP1,81170030-BS'
          }, {
            id: 32,
            date: '2023-11-03',
            name: '1',
            address: 'TECH',
            machineId: '2',
            quantity: '2000',
            img: 'http://45.32.181.176:8081/42b8e8b55db848889c10eae020e1857f.png',
            itmes: 'TOOL-BM-CP,BAM1191-CL,BAM1306-FIL,BAM1290-FC,BAM1344-BL,BAM1207-BTL,BAM1207-PU,BAM1207-AC,BAM1313-TB,BAM1313-FIL,BAM1283-FIL'
          }
        ])
      }, 1000)
    },
    chooseDate () {
      console.log(this.value)
    }
  }
}
</script>

<style scoped>

</style>
